import { render, staticRenderFns } from "./tags-modal.vue?vue&type=template&id=3119bc86&scoped=true"
import script from "./tags-modal.vue?vue&type=script&lang=js"
export * from "./tags-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119bc86",
  null
  
)

export default component.exports